import { css } from 'lit';

export const styles = css`:host{color:var(--actions-text-color)}`;
